import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTabData } from "../../redux/programs/ProgramsAction";
import { Rotate, Fade } from 'react-reveal';

import CustomButton from "../../components/CustomButton";
import WorkoutsImageGroup from "../../components/WorkoutsImageGroup";
import WorkoutGroup from "./inPersonImageGroup";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const VirtualWorkouts = () => {
  const dispatch = useDispatch();
  const handleTab = () => {
    dispatch(setTabData(CONSTANTS.TABS.VIRTUAL));
    window.scrollTo(0, 0);
  };
  return (
    <div className="virtual-workouts">
      <Fade left >
        <div className="virtual-left">
          <div className="title">Virtual workouts</div>
          <div className="para">
            Taking our customized, convenient, and creative approach one step further, virtual training with Omni-Active®
            Fitness allows our clients to get a great workout, regardless of their whereabouts. Live workouts with a
            trainer allow us to adjust on-the-fly when needed, but a virtual approach delivers on unmatched convenience by
            allowing you to train anywhere, anytime.
        </div>
          <div className="line">You get</div>
          <div className="types">
            <div className="type">Virtual</div>
            <div className="type">Online</div>
          </div>
          <Link to="/programs" onClick={handleTab}>
            <CustomButton type={CONSTANTS.ROUNDED_TYPE}>View Details</CustomButton>
          </Link>
        </div>
      </Fade>
      <Rotate top>
        <div className="virtual-right">
          <WorkoutGroup
            phoneOne={CONSTANTS.phoneOne}
            phoneTwo={CONSTANTS.phoneTwo}
            largeImage={CONSTANTS.VirtualLargeImage}
          />
        </div>
      </Rotate>
    </div>
  );
};

export default VirtualWorkouts;
